export default __webpack_public_path__ + "static/media/white.de835116.svg";